var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.088,
    height: 20.088,
    viewBox: "0 0 20.088 20.088",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-checkmark-circle-outline",
    "data-name": "Icon ionic-ios-checkmark-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93209",
    "data-name": "Path 93209",
    d: "M20.778,13.138l-.85-.874a.183.183,0,0,0-.135-.058h0a.175.175,0,0,0-.135.058L13.766,18.2l-2.144-2.144a.187.187,0,0,0-.27,0l-.86.86a.192.192,0,0,0,0,.275l2.7,2.7a.855.855,0,0,0,.565.275.9.9,0,0,0,.56-.266h0l6.456-6.49A.206.206,0,0,0,20.778,13.138Z",
    transform: "translate(-2.211 -2.766)",
    fill: "#4ec156"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93210",
    "data-name": "Path 93210",
    d: "M13.419,4.727A8.689,8.689,0,1,1,7.272,7.272a8.635,8.635,0,0,1,6.147-2.545m0-1.352A10.044,10.044,0,1,0,23.463,13.419,10.043,10.043,0,0,0,13.419,3.375Z",
    fill: "#4ec156"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.1c9324da41eda63f90885746f339da5e.svg";
export { ForwardRef as ReactComponent };